import { tabClasses as muiTabClasses } from '@mui/material/Tab';

import theme from '@/theme';

const ns = `tab`;

export const tabClasses = {
  root: `${ns}__root`,
};

const styles = {
  tab: {
    [`&.${muiTabClasses.root}`]: {
      fontFamily: theme.typography.fontFamily,
      fontSize: '16px',
      paddingBottom: '0px',
      color: 'var(--onSurfaceSecondary)',
      [`& .${muiTabClasses.selected}`]: {
        color: 'var(--brandPrimary)',
      },
      [`& .${muiTabClasses.disabled}`]: {
        color: 'var(--onSurfaceSubtle)',
      },
    },
  },
};

export default styles;
